<div class="flex flex-col gap-6">

  <!-- Resumen de filtros activos (contexto modal/móvil) -->
  @if (showActiveFilters() && (statesValue.length > 0 || modesValue.length > 0)) {
    <div class="space-y-3 lg:hidden">
      <div class="flex flex-wrap gap-2 font-title">
        @for (group of stateGroups; track group.label) {
          @if (isStateGroupSelected(group.values)) {
            <button
              class="relative group cursor-pointer"
              [class]="getBadgeClass(group.label)"
              (click)="toggleStateGroup(group.values)">
              {{ group.label }}
              <lib-icon name="close-small"></lib-icon>
            </button>
          }
        }
        @for (mode of modesValue; track mode) {
          <button
            class="relative group cursor-pointer"
            [class]="getModeBadgeClass(mode)"
            (click)="toggleMode(mode)">
            {{ sectorUiService.getSectorModeString($any(mode)) }}
            <lib-icon name="close-small"></lib-icon>
          </button>
        }
      </div>
      <button class="text-xs underline text-gray-500 font-medium cursor-pointer hover:text-gray-700 transition-colors" (click)="clearFilters()">Limpiar filtros</button>
    </div>
  }

  <!-- Filtrar por -->
  <div class="bg-white rounded-2xl shadow-sm border border-gray-200">
    <div class="py-4 px-6 border-b border-gray-200">
      <h4 class="font-medium text-gray-800 font-title">Filtrar por</h4>
    </div>

    <div class="p-6 space-y-6">
      <!-- Estado -->
      <div class="space-y-3">
        <p class="text-sm font-title text-gray-700 font-medium">Estado</p>
        <div class="flex flex-wrap gap-2">
          @for (group of stateGroups; track group.label) {
            <button class="px-3 py-2 rounded-lg text-sm transition-all duration-200 font-medium font-title cursor-pointer border hover:scale-105 active:scale-95"
              [ngClass]="getStateGroupClass(group.label, group.values)"
              (click)="toggleStateGroup(group.values)">
              {{ group.label }}
            </button>
          }
        </div>
      </div>

      <!-- Modo -->
      <div class="space-y-3">
        <p class="text-sm font-title text-gray-700 font-medium">Modo</p>
        <div class="flex flex-wrap gap-2">
          @for (mode of modes; track mode) {
            <button class="px-3 py-2 rounded-lg text-sm transition-all duration-200 font-medium font-title cursor-pointer border hover:scale-105 active:scale-95"
              [ngClass]="getModeClass(mode)"
              (click)="toggleMode(mode)">
              {{ sectorUiService.getSectorModeString(mode) }}
            </button>
          }
        </div>
      </div>

      <!-- Punto de extensión: desplegables por pantalla (Propietario / Arrendatario / ...) irán aquí -->
    </div>
  </div>

  <!-- Ordenar por -->
  <div class="bg-white rounded-2xl shadow-sm border border-gray-200">
    <div class="py-4 px-6 border-b border-gray-200">
      <h4 class="font-medium text-gray-800 font-title">Ordenar por</h4>
    </div>
    <div class="p-6">
      <lib-select
        [options]="orderOptions()"
        [value]="orderValue"
        (valueChange)="setOrder($event)"
        className="w-full">
      </lib-select>
    </div>
  </div>

</div>
